import { render } from "./mendian_position.vue?vue&type=template&id=ec047bae&scoped=true"
import script from "./mendian_position.vue?vue&type=script&lang=js"
export * from "./mendian_position.vue?vue&type=script&lang=js"

import "./mendian_position.vue?vue&type=style&index=0&id=ec047bae&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec047bae"]])

export default __exports__